import { has } from 'lodash';
import Constants from '../Constants';
import * as Helpers from '../Utilities/Common';
import { normalizeData } from '../Schemas';


const { STATS, STATS_LOADING, STATS_CHANGE } = Constants;

export const getStats = (token, query = {}) => async (dispatch) => {
    dispatch({ type: STATS_LOADING, payload: true });
    const statsQuery = !has(query,'status') ? {...query }: {...query, status: [...query.status,5]};
    const response = await Helpers.makeRequest(token,'STATS','GET','',statsQuery);
    if(response.result){
        const normalizedData = normalizeData({ data: response.data },'stats');
        dispatch({ type: STATS, payload: normalizedData.entities.stats });
    }
}

export const changeStats = (id, increment = true) => ({ type: STATS_CHANGE, payload: {id, increment} });





// WEBPACK FOOTER //
// ./src/Actions/DashboardActions.js